<template>
  <!-- 标题 -->
  <div class="title">
    <div class="line"></div>
    <div class="txt">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ts-title",
  props: {
    title: {
      type: String, //值的类型
      required: true //是否符合规定
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.title {
  display: flex;
  align-items: center;
}
.title .line {
  width: 3px;
  height: 16px;
  background: #1476F9;
}
.title .txt {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/title.vue